export const QA_NAME_COLOR_PICKER_POPOVER_PREVIEW_INPUT =
  'color_picker_popover_preview_input'

export const RGB_CHANNEL_MIN = 0

export const RGB_CHANNEL_MAX = 255

export const RGB_CHANNEL = {
  b: 'b',
  g: 'g',
  r: 'r',
}
